import React, { FC, useMemo } from 'react'
import dayjs from '../../utils/dayjs'

interface ITimeFormat {
    time: string,
}

const TimeFormat: FC<ITimeFormat> = ({ time }) => {
    const formatTime = useMemo(() => dayjs(time).format('HH:mm'), [time])
    return <time>{formatTime}</time>
}

export default TimeFormat